module.exports = __webpack_public_path__ + "images/587f193749fa6415d02a3b38669218dee60082ffc3e2dcab580cfc57b8adf34f.svg";